import { render } from "./ReportExport.vue?vue&type=template&id=37c96222&scoped=true&ts=true"
import script from "./ReportExport.vue?vue&type=script&lang=ts"
export * from "./ReportExport.vue?vue&type=script&lang=ts"

import "./ReportExport.vue?vue&type=style&index=0&id=37c96222&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c96222"]])

export default __exports__